'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ClientShowCtrl
 * @description
 * # ClientShowCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ClientShowCtrl', [
    '$scope', '$state', '$stateParams', 'Client', function ($scope, $state, $stateParams, Client) {
      $scope.client = {};
      Client.find($stateParams.clientId).then(function(response) {
        $scope.client = response.data.client;
      }, function(error) {
        Client.error(error);
      });
  }]);
